import { Card } from "./ui/card";
import { useState, useEffect } from "react";
import {
    GraduationCap,
    ClipboardList,
    Users,
    Shapes,
    ShieldAlert,
    BookOpen,
} from "lucide-react";
import drawing5 from "../assets/drawing5.png";
import drawing6 from "../assets/drawing6.png";
import drawing7 from "../assets/drawing7.png";
import drawing8 from "../assets/drawing8.png";
import drawing9 from "../assets/drawing9.png";
import drawing10 from "../assets/drawing10.png";

export const UseCases = () => {
    const images = [drawing5, drawing6, drawing7, drawing8, drawing9, drawing10];
    const [index, setIndex] = useState(0);

    const useCases = [
        {
            label: "Classroom Sessions",
            icon: GraduationCap,
            accent: "bg-cyan-300",
        },
        {
            label: "Advisory Programs",
            icon: ClipboardList,
            accent: "bg-yellow-300",
        },
        {
            label: "Peer Support Groups",
            icon: Users,
            accent: "bg-pink-300",
        },
        {
            label: "School Clubs",
            icon: Shapes,
            accent: "bg-violet-300",
        },
        {
            label: "Anti-Bullying Initiatives",
            icon: ShieldAlert,
            accent: "bg-red-300",
        },
        {
            label: "Character Education",
            icon: BookOpen,
            accent: "bg-green-300",
        },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <section id="use-cases" className="bg-[#f8f4ea] py-20">
            <div className="container mx-auto max-w-6xl px-4">
                <Card className="rounded-[28px] border-[4px] border-black bg-[#f8f4ea] p-8 text-black shadow-[10px_10px_0_#000] md:p-10">
                    <div className="grid items-start gap-10 md:grid-cols-[1.2fr_0.8fr]">
                        {/* LEFT */}
                        <div>
                            <div className="mb-6 inline-block border-[3px] border-black bg-red-500 px-4 py-2 text-xl font-black uppercase text-white shadow-[3px_3px_0_#000]">
                                Perfect For
                            </div>

                            <div className="grid gap-4 sm:grid-cols-2">
                                {useCases.map((useCase, i) => {
                                    const Icon = useCase.icon;

                                    return (
                                        <div
                                            key={i}
                                            className="group relative overflow-hidden rounded-[18px] border-[3px] border-black bg-white p-4 shadow-[5px_5px_0_#000] transition-transform duration-200 hover:-translate-y-1"
                                        >
                                            <div
                                                className={`absolute left-0 top-0 h-full w-3 border-r-[3px] border-black ${useCase.accent}`}
                                            />

                                            <div className="pl-4">
                                                <div className="mb-3 flex items-center gap-3">
                                                    <div className="flex h-12 w-12 items-center justify-center rounded-[14px] border-[3px] border-black bg-[#f8f4ea] shadow-[3px_3px_0_#000]">
                                                        <Icon className="h-5 w-5" />
                                                    </div>

                                                    <span className="text-sm font-bold uppercase leading-tight md:text-[0.95rem]">
                                                        {useCase.label}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* RIGHT */}
                        <div className="flex h-full items-center justify-center">
                            <div className="relative w-full max-w-[420px] rounded-[20px] border-[4px] border-black bg-[#ece7dc] p-4 shadow-[6px_6px_0_#000]">
                                <div className="absolute inset-0 opacity-10 [background-image:radial-gradient(#000_1.2px,transparent_1.2px)] [background-size:16px_16px]" />

                                <div className="relative overflow-hidden border-[4px] border-black bg-white shadow-[6px_6px_0_#000]">
                                    <img
                                        src={images[index]}
                                        alt="Student illustration"
                                        className="h-full w-full object-cover opacity-90 saturate-[0.9] transition-all duration-500"
                                    />
                                </div>

                                <div className="relative mt-4 flex justify-center gap-2">
                                    {images.map((_, i) => (
                                        <div
                                            key={i}
                                            className={`h-3 w-3 rounded-full border-2 border-black ${
                                                i === index ? "bg-red-500" : "bg-white"
                                            }`}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        </section>
    );
};